// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HC2Pm","name":"styles_name__3yguf","phone":"styles_phone__3zP-M"};